module.exports = __webpack_public_path__ + "images/file_icons_v2/pptx-1b3704a895a5259c1639574b9f501271.svg";